// Add flags you want to use on the project

export const flagsAXP = [
  'flagAxpAdvancedSearch',
  'flagAxpAiSearch',
  'flagAxpBuilderHtmlPreview',
  'flagAxpBuilderTemplates',
  'flagAxpDigestTinyMce',
  'flagAxpEmailBuilderComponentsRedesign',
  'flagAxpEmailListPosts',
  'flagAxpEmailListDiscussions',
  'flagAxpEmailListOpportunities',
  'flagAxpEmailListUsers',
  'flagAxpEmailListProjects',
  'flagAxpEmailListTrips',
  'flagAxpEngagementScoringPerfImprovement',
  'flagAxpJimo',
  'flagAxpUserEvents',
  'flagAxpUserListsIndexRevamp',
  'flagBuilderLazyLoadSections',
  'flagBuilderPageGlobalStorage',
  'flagBuilderRemoveColumnBackground',
  'flagBuilderUploadDownloadZip',
  'flagBuilderUploadVideo',
  'flagBuilderWeightLimitation',
] as const;

export const flagsIM = [
  'flagImEmojiPicker',
  'flagImCustomEmojiReactions',
] as const;

export default [
  ...flagsAXP,
  ...flagsIM,
  'flagActivateFrontMonitoringDatadog',
  'flagAxpBrandingAvatarToGlobalStorage',
  'flagAxpBrandingFaviconToGlobalStorage',
  'flagAxpBrandingMobileHeaderLogoToGlobalStorage',
  'flagAxpBrandingWebsiteFooterLogoToGlobalStorage',
  'flagAxpCampaignsCkDeprecation',
  'flagBraintree3DSecureSca',
  'flagCurrentSessionContext',
  'flagDsIsolationNewsDetailPage',
  'flagEvAblyInactivityTracker',
  'flagEvAiFormAssistantOnForums',
  'flagEvAiFormAssistantOnNews',
  'flagEvBlockContentUploadCkEditor',
  'flagEvEventsBoRevamp',
  'flagEvForumSummary',
  'flagEvGeoboxSearch',
  'flagEvGsMembershipLogo',
  'flagEvImproveSoldOutEventsFo',
  'flagEvMentoringAdminMatch',
  'flagEvMessagingReactQuery',
  'flagEvMultiplePromoCodes',
  'flagEvNewEventFoCard',
  'flagEvNewsPackage',
  'flagEvNewsRevamp',
  'flagEvOrderSummaryDsEvents',
  'flagEvPaymentsMovePromocode',
  'flagEvPolls',
  'flagEvReactions',
  'flagEvRecaptchaToTurnstile',
  'flagEvStandaloneZoom',
  'flagEvStripeCobrandedCards',
  'flagEvStripeDirectChargeForAllCC',
  'flagEvSuperAdminReadOnly',
  'flagEvTinyMce',
  'flagEvUserPicturesToGlobalStorage',
  'flagEvVirusScanning',
  'flagEvZoomAttendanceTracking',
  'flagGoogleMapsComponent',
  'flagMobileAppsBoOptionalAndroidServiceAccountJson',
  'flagProfileCustomHeader',
  'flagRequestUserAccountDeletion',
  'flagSuEmailSecurity',
  'flagSuNotifSignin',
  'flagUeMobileCaretFooter',
  'flagUeNewOutdatedBrowserDetection',
  'flagUeSearchDeactivateGlobal',
  'flagUjAblyClientMigration',
  'flagUjAblyInternalNotifications',
  'flagUjAiContentRecommendation',
  'flagUjAiContentRecommendationAllTypes',
  'flagUjAiContentRecommendationForumEvents',
  'flagUjAiGlobalSearch',
  'flagUjAiSelectContentType',
  'flagUjAiUserProfileSummary',
  'flagUjAiUserRecommendation',
  'flagUjAnchoringComments',
  'flagUjbBiggerBadgeSize',
  'flagUjbLfPagination',
  'flagUjNotificationsCommentsImprovement',
  'flagUjNotificationsNotifyImprovement',
  'flagUjUserProfilePerf',
  'flagUjUserprofileRedesignWave1',
  'flagUjSearchLocationAnonymous',
  'flagUjUserProfileSnapshot',
  'flagUseWhitelabelCustomCertificate',
  'flagUseHydraInWebappAdmin',
] as const;
